import { useCallback } from 'react';
import { useMutation } from 'react-apollo';
import { mutations } from '@kiper/account-graphql/auth';

/**
 * Verifica se a conta existe e se exige autorização de estação de trabalho.
 * @returns {(email: string) => Promise<{ exists: boolean, workstationAuthorizationRequired?: boolean }>}
 */
export default function useCheckUserExist() {
  const [checkEmail] = useMutation(mutations.checkUserExistV2);

  return useCallback(
    async email => {
      const { data } = await checkEmail({ variables: { username: email } });
      return data?.checkUserExistV2 || { exists: false };
    },
    [checkEmail],
  );
}
